module.exports = __webpack_public_path__ + "ui/img/teambot-app-logo-vector-512.e06430eb.png";